import { GetCompanyDocumentsResponse, IDocument } from '../services/Interfaces/IAccountService';

const getDocsFromShareholders = (data: GetCompanyDocumentsResponse['data']): IDocument[] => {
  const docs: IDocument[] = [];

  data.shareholders.forEach((shareholder) => {
    // Process address documents
    shareholder.address.forEach((doc) => {
      docs.push({
        ...doc,
        shareholder_name: shareholder.name,
        is_director: shareholder.is_director,
        document_type: 'address'
      });
    });

    // Process regular documents
    shareholder.documents.forEach((doc) => {
      docs.push({
        ...doc,
        shareholder_name: shareholder.name,
        is_director: shareholder.is_director,
        document_type: 'document'
      });
    });

    // Process passport documents
    shareholder.passports.forEach((doc) => {
      docs.push({
        ...doc,
        shareholder_name: shareholder.name,
        is_director: shareholder.is_director,
        document_type: 'passport'
      });
    });
  });

  return docs;
};

export { getDocsFromShareholders };
